import React from 'react';
import PropTypes from 'prop-types';
import { AlertModal, Text } from '@cashfree-intl/coherent';

const ConnectPaytmAccountSuccess = ({ closeModal }) => (
  <AlertModal
    type="success"
    title="Paytm Activated Successfully"
    onClose={closeModal}
    eventNameOnClose="Paytm_Activated_Successfully_Close"
  >
    <Text variant="p14" color="bodyLight">
      Your Paytm wallet has been successfully linked with Cashfree. It will now
      appear as a payment option on your checkout page.
    </Text>
  </AlertModal>
);

ConnectPaytmAccountSuccess.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default ConnectPaytmAccountSuccess;
